module.exports = __webpack_public_path__ + "static/media/fru.0cc099e5.jpeg";